// extracted by mini-css-extract-plugin
export default {"error":"defaultErrorFallback_error__nit9X"};